module.exports = __webpack_public_path__ + "img/7.be05cb09.jpg";